import * as T from '@/types'

import { CrudResource } from '@/api/resources/api-crud'

const routes : {[key: string] : string} = {
    Index: 'creditor',
    Show: 'creditor/${id}',
}

export class CreditorsResource extends CrudResource<T.Creditor>{

    get crudBaseCalls () {
        const api = this.api

        return {
            index (filters?: T.Filters, queryParams?: any) {
                return api.get(routes.Index)
            },
            page (pageRoute: string) {
                return api.get(pageRoute)
            },
            show (id: T.EntityId) {
                return api.get(routes.Show.replace('${id}', id))
            },
        }
    }

    item (data: any) {
        return data
    }

    items (data: any) {
        return data
    }

    map (data: any) {
        return {
            createdAt: data.createdAt,
            email: data.email,
            id: data.id,
            name: data.name,
            updatedAt: data.updatedAt,
            creditorGroupId: data.creditorGroupId,
            legacyId: data.legacyId,
            verificationSource: data.verificationSource,
            verificationSourceIdentifier: data.verificationSourceIdentifier,
        }
    }

}

export default function (api: T.CreditorDeskApi) {
    return new CreditorsResource(api)
}
